// extracted by mini-css-extract-plugin
export var caption = "style-module--caption--0cb69";
export var label = "style-module--label--bba30";
export var option = "style-module--option--c3844";
export var select = "style-module--select--5d140";